export default "__VITE_ASSET__a86c991e__"